/**
 * QBranchPersonnelServiceModule — 2026-06-08 Phase 5D wire-up for the
 * canonical Q Manual VG35002 Q Branch personnel REST surface (Phase 5C
 * commit e0decef97).
 *
 * Routes (per briefing_room_backend/routes/q_branch_personnel.py):
 *   GET /api/modules/briefing-room/q-branch-personnel             → PersonnelManifest
 *   GET /api/modules/briefing-room/q-branch-personnel/{id}        → full dossier | 404
 *
 * Auth: Bearer JWT from localStorage via getAuthHeaders().
 */
import { getAuthHeaders } from './authHeaders';

export type PersonnelCategory = 'leadership' | 'harrow_club' | 'newer_member';

export interface PersonnelManifestEntry {
  id: string;
  name: string;
  code_name: string | null;
  rank: string | null;
  role: string | null;
  category: PersonnelCategory;
  page: number | null;
}

export interface PersonnelManifest {
  personnel: PersonnelManifestEntry[];
  total: number;
  categories_complete: string[];
  categories_pending: string[];
  schema_version: string;
  source: string;
}

const BASE_PATH = '/api/modules/briefing-room/q-branch-personnel';

export class QBranchPersonnelServiceModule {
  constructor(
    private readonly fetchFn: typeof fetch = (input, init) => fetch(input, init),
  ) {}

  async list(): Promise<PersonnelManifest> {
    const resp = await this.fetchFn(BASE_PATH, {
      method: 'GET',
      headers: { ...getAuthHeaders() },
    });
    if (!resp.ok) {
      throw new Error(
        `QBranchPersonnelServiceModule: list HTTP ${resp.status}`,
      );
    }
    return (await resp.json()) as PersonnelManifest;
  }

  async get(personnelId: string): Promise<Record<string, unknown> | null> {
    const resp = await this.fetchFn(
      `${BASE_PATH}/${encodeURIComponent(personnelId)}`,
      {
        method: 'GET',
        headers: { ...getAuthHeaders() },
      },
    );
    if (resp.status === 404) {
      return null;
    }
    if (!resp.ok) {
      throw new Error(
        `QBranchPersonnelServiceModule: get HTTP ${resp.status}`,
      );
    }
    return (await resp.json()) as Record<string, unknown>;
  }
}
